import { SUBSCRIPTION_PLAN as TARIFF_PLAN } from 'interfaces/subscriptions';

export const accessAllTariffPlansList = [
  TARIFF_PLAN.FREE,
  TARIFF_PLAN.LIGHT,
  TARIFF_PLAN.STANDARD,
  TARIFF_PLAN.STARTER,
  TARIFF_PLAN.UNAUTHORIZED,
];
export const accessLightAndStandardPlansList = [TARIFF_PLAN.FREE, TARIFF_PLAN.LIGHT, TARIFF_PLAN.STANDARD]; // temporary for TARIFF_PLAN.FREE
export const accessStandardPlansList = [TARIFF_PLAN.STANDARD];
export const accessFreeStandardAndLightPlansList = [TARIFF_PLAN.LIGHT, TARIFF_PLAN.STANDARD, TARIFF_PLAN.FREE];
export const accessStarterStandardAndLightPlansList = [TARIFF_PLAN.LIGHT, TARIFF_PLAN.STANDARD, TARIFF_PLAN.STARTER];
